import React from 'react'

import { Form } from '_zari/core'

import * as CentroCostoService from 'services/centrosCosto.service'

const SelectCentroCostoNivel2 = ({ idNodoPadre, optionsRef, oneRowTrigger, ...props }) => {
  const [partidas, setCentrosCosto] = React.useState([])

  React.useEffect(() => {
    CentroCostoService.obtenerNodosHijosxIdAsSelect(idNodoPadre)
      .then(({ data }) => {
        setCentrosCosto(data)
        if (data && data.length === 1 && oneRowTrigger) {
          oneRowTrigger(data[0])
        }
        if (optionsRef) {
          optionsRef.current = data
        }
      })
      .catch(() => setCentrosCosto([]))
  }, [optionsRef, idNodoPadre, oneRowTrigger])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {partidas.map(x => (
        <option key={x._id} value={x._id}>{`${x.codigo} - ${x.descripcion}`}</option>
      ))}
    </Form.Select>
  )
}

export default React.memo(SelectCentroCostoNivel2)
